import React from 'react';
import { Alert } from 'antd';
import { WebsiteIndexEntry, UpdateWebsiteIndexEntrySettingsParams } from '../../../deepAnalysis/websiteIndexEntry/types';
import { useUpdateWebsiteIndexEntrySettingsMutation } from '../../../deepAnalysis/websiteIndexEntry/service';
import NotificationsInput from './NotificationsInput';


type Props = {
    selectedWebsite: WebsiteIndexEntry;
};


export default function NotificationsTab({ selectedWebsite }: Props) {
    const [updateSettings] = useUpdateWebsiteIndexEntrySettingsMutation();

    const handleUpdateNotifications = async (args: UpdateWebsiteIndexEntrySettingsParams) => {
        try {
            await updateSettings(args).unwrap();
        } catch (error) { }
    };

    return (
        <div className="notifications-tab">
            <Alert
                className="disclaimer"
                message="Please note!"
                description={
                    <>
                        By enabling the notifications below, you confirm that you want to receive email alerts when certain events happen on your website:{' '}
                        <a
                            href={selectedWebsite.homepage_url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {selectedWebsite.homepage_url}
                        </a>
                    </>
                }
                type="info"
                showIcon
            />
            <NotificationsInput
                key={selectedWebsite.guid}
                selectedWebsite={selectedWebsite}
                onUpdateNotifications={handleUpdateNotifications}
            />
        </div>
    );
}
